import { DRIVE_TAB } from "./tabConstants";

export type SortParams = {
  mt?: "asc" | "desc";
  mtuser?: "asc" | "desc";
  "title.keyword"?: "asc" | "desc";
  "meta.duration"?: "asc" | "desc";
};

export const transformSortByToSortParams = (sortBy: string): SortParams => {
  switch (sortBy) {
    case "newest":
      return { mt: "desc" };
    case "oldest":
      return { mt: "asc" };
    case "recent":
      return { mtuser: "desc" };
    case "asc":
      return { "title.keyword": "asc" };
    case "desc":
      return { "title.keyword": "desc" };
    case "longest":
      return { "meta.duration": "desc" };
    case "shortest":
      return { "meta.duration": "asc" };
    default:
      return { mt: "desc" };
  }
};

export const getHeaders = (activeType: string) => {
  const baseHeaders = [
    { name: "Title", width: "40%" },
    { name: "Created", width: "12%" },
    { name: "Team/Property", width: "12%" },
    { name: "Status", width: "10%" },
  ];
  if (activeType === DRIVE_TAB) {
    return [
      { name: "Title", width: "40%" },
      { name: "Created", width: "12%" },
      { name: "Team/Property", width: "14%" },
      { name: "Used By", width: "34%" },
    ];
  } else {
    return [
      ...baseHeaders,
      { name: "Published To", width: "16%" },
      { name: "Reach", width: "10%" },
    ];
  }
};

export const TabMapping = {
  video: ["video", "campaign", "slates"],
  audio: "audio",
  shorts: "shorts",
  premiere: "premiere",
};
